import { writable, derived } from 'svelte/store';
import V3Factory from '../helpers/V3';
import { isAlreadyLiked } from '../helpers/map';
import { getUrlParam } from '../helpers/url';
import { branding, industryCategoryGroup, obxEndpoint, shortname, } from '../helpers/consts';
import './service';
import Cookies from 'js-cookie';
const V3 = V3Factory(obxEndpoint, shortname, shortname);
const wishlist = writable([]);
const count = derived(wishlist, ($wishlist) => $wishlist.length);
const ids = derived(wishlist, ($wishlist) => $wishlist.map((item) => ({
    AdCampaignCode: null,
    ProductId: item.Id,
    Commence: item.Commence,
    Conclude: item.Conclude,
    Pax: {
        Adults: item.Guest,
        Children: 0,
        Seniors: 0,
    },
    TotalPrice: item.Price,
    DealCampaignCode: null,
})));
const visible = writable(false);
const no_image = 'https://digitalfinger.id/wp-content/uploads/2019/12/no-image-available-icon-6-600x375.png';
function add(service, bookingQuote, startTimeIndex) {
    wishlist.update((value) => {
        if (alreadyExist(service.Id)) {
            value.splice(findIndex(value, service.Id), 1);
        }
        else {
            value.push(prepare(service, bookingQuote, startTimeIndex));
        }
        persistToCookies(value);
        return value;
    });
    runSideEffects(service);
}
function runSideEffects(service) {
    isAlreadyLiked(service.Id);
}
function prepare({ Id, Name, Thumbnail, Type }, bookingQuote, startTimeIndex) {
    return {
        Id: Id,
        Name: Name,
        Thumbnail: Thumbnail,
        Type: Type,
        Price: bookingQuote.Configurations[0].Quotes[startTimeIndex].TotalPrice,
        Guest: bookingQuote.Configurations[0].Pax.Adults,
        Night: bookingQuote.Configurations[0].Quotes[startTimeIndex].Duration,
        Commence: bookingQuote.Configurations[0].Quotes[startTimeIndex].Commence,
        Conclude: bookingQuote.Configurations[0].Quotes[startTimeIndex].Conclude,
    };
}
function remove(service) {
    wishlist.update((value) => {
        value.splice(findIndex(value, service.Id), 1);
        persistToCookies(value);
        return value;
    });
}
function findIndex(array, id = null) {
    return array.findIndex((item) => item.Id === id);
}
function init() {
    let savedWishlist = [];
    if (Cookies.get('wishlist')) {
        savedWishlist = JSON.parse(Cookies.get('wishlist'));
    }
    wishlist.set(savedWishlist);
}
function persistToCookies(wishlist) {
    wishlist = JSON.stringify(wishlist);
    Cookies.set('wishlist', wishlist, { expires: 1 });
}
function show() {
    visible.set(true);
}
function hide() {
    visible.set(false);
}
function goToCABS() {
    let products = [];
    const unsubscribe = ids.subscribe((value) => (products = value));
    unsubscribe();
    const favourites = {
        Products: products,
    };
    /* Nara custom logic */
    let distributor = '';
    let exl_mod = 'acc,act,shp';
    let exl_grp = 'shp';
    let exl_grps = ['acc', 'act', 'epc', 'shp'];
    const selectedType = getUrlParam('type');
    if (selectedType && selectedType === industryCategoryGroup.isRestaurant) {
        if (getUrlParam('on_req') === 'true') {
            distributor = 'NaratabiB_On';
        }
        else if (getUrlParam('on_req') === 'false') {
            distributor = 'NaratabiB';
        }
        exl_mod = 'epc';
        exl_grp = 'epc';
    }
    if (selectedType && selectedType !== industryCategoryGroup.isRestaurant) {
        exl_grp =
            exl_grps[selectedType] !== undefined
                ? exl_grps[selectedType]
                : 'acc';
    }
    /* Nara custom logic */
    V3.setExtraExlData([
        {
            name: 'exl_mod',
            value: exl_mod,
        },
        {
            name: 'exl_grp',
            value: exl_grp,
        },
    ]);
    V3.redirectToCABS(favourites, distributor, branding);
}
function alreadyExist(id) {
    let idArray = [];
    const unsub = ids.subscribe((value) => (idArray = value));
    const _isExist = idArray.includes(id);
    unsub();
    return _isExist;
}
let store;
export default store = {
    subscribe: wishlist.subscribe,
    init,
    add,
    remove,
    show,
    hide,
    goToCABS,
    count,
    visible: { subscribe: visible.subscribe },
    ids,
    alreadyExist,
};
